(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('omriyana-size-guide')) {
    customElements.define('omriyana-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.picker = this.closest('variant-picker');
        this.dialog = this.querySelector('dialog');
        this.picker.addEventListener('click', event => {
          const opener = event.target.closest('[data-omriyana-guide-open]');
          if (!opener) return;
          this.opener = opener;
          const fieldset = opener.closest('fieldset');
          const selected = fieldset?.querySelector('input:checked')?.value;
          this.querySelectorAll('[data-guide-size]').forEach(row => {
            if (row.dataset.guideSize === selected) row.setAttribute('aria-current', 'true');
            else row.removeAttribute('aria-current');
          });
          this.querySelector('[data-guide-selected-label]').textContent = selected ? ' · Size ' + selected + ' selected' : '';
          this.dialog.showModal();
        }, options);
        this.addEventListener('click', event => {
          if (event.target.closest('[data-guide-close]')) this.dialog.close();
          const unitButton = event.target.closest('[data-guide-unit]');
          if (!unitButton) return;
          const unit = unitButton.dataset.guideUnit;
          this.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unitButton)));
          this.querySelectorAll('[data-guide-unit-label]').forEach(label => label.textContent = unit);
          this.querySelectorAll('[data-cm]').forEach(cell => cell.textContent = unit === 'cm' ? cell.dataset.cm : (Number(cell.dataset.cm) / 2.54).toFixed(1));
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus({ preventScroll:true });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
